module.exports = __webpack_public_path__ + "static/media/map_pin_mid.602f9df1.svg";